<template>
  <div class="side_content">
    <div
      class="side_item"
      v-for="(tab, index) in curTabs"
      :key="index"
      @click="activeTab(index)"
      :class="{ active: isSelected(index) }"
    >
      {{ tab.name }}
    </div>
  </div>
</template>

<script>
import { i3DBridge } from '@/utils/i3DBridge';
import EventBus from '@/eventBus.ts';
import * as Api from '@/api';
export default {
  name: 'TabSide',
  props: {
    curTab: {
      type: String,
      default: '电站总览',
    },
  },
  data() {
    return {
      tabs: [
        { code: 'fdjz', name: '发电机组', isActive: false, viewCode: 'JK007', changeView: false },
        { code: 'fjsb', name: '辅机设备', isActive: false, viewCode: 'JK006', changeView: false },
        { code: 'spjk', name: '视频监控', isActive: false, viewCode: '', changeView: false },
        { code: 'sgjz', name: '水工建筑', isActive: false, viewCode: '', changeView: false },
        { code: 'cgpx', name: '参观培训', isActive: false, viewCode: '', changeView: false },
      ],
      tabs2: [
        { code: 'dzcg', name: '电站参观', isActive: false, viewCode: 'JK001', changeView: false },
        // { code: 'dzyw', name: '电站运维', isActive: false, viewCode: 'JK001', changeView: false },
        { code: 'dzyy', name: '电站预演', isActive: false, viewCode: '', changeView: false },
      ],
      curTabs: [],
      selectedTab: null,
      machineArr: [
        'SLJ001',
        'SLJ002',
        'SLJ003',
        'SLJ004',
        'SLJ005',
        'SLJ006',
        'SLJ007',
        'SLJ008',
        'SLJ009',
        'SLJ010',
        'SLJ011',
        'SLJ012',
        'SLJ013',
        'SLJ014',
        'SLJ015',
        'FDJ001',
        'FDJ002',
        'FDJ003',
        'FDJ004',
        'FDJ005',
        'FDJ006',
        'FDJ007',
        'FDJ008',
      ],
      machineHighLightState: false,
    };
  },
  watch: {
    curTab: function (newV, oldV) {
      this.selectedTab = null;
      if (newV == '预警预演') {
        this.curTabs = this.tabs2;
      } else {
        this.curTabs = this.tabs;
      }
    },
  },
  mounted() {
    if (this.curTab == '预警预演') {
      this.curTabs = this.tabs2;
    } else {
      this.curTabs = this.tabs;
    }

    EventBus.$on('curSideTabIndex', (data) => {
      console.log('data :>> ', data);
      this.activeTab(data);
    });
  },
  methods: {
    activeTab(index) {
      if (index < 0) {
        this.selectedTab = index;
        EventBus.$emit('curSideTab', 'home');
      }
      this.$Model.i3dInit();
      if (this.machineHighLightState) {
        setTimeout(() => {
          // 取消高亮整个发电机组
          this.$Model.i3dHighLight(this.machineArr, 'T1', '0', '1');
          this.machineHighLightState = false;
        }, 300);
      }
      this.selectedTab = index;
      EventBus.$emit('curSideTab', this.curTabs[index].name);
      const { viewCode, code, changeView } = this.curTabs[index];
      if (viewCode && changeView) {
        // 去到对应视角
        this.$Model.i3dChangeViewByCode(viewCode);
      }
      if (code == 'fdjz') {
        setTimeout(() => {
          // 高亮整个发电机组
          this.$Model.i3dHighLight(this.machineArr, 'T1', '1', '1');
          this.machineHighLightState = true;
        }, 600);
        setTimeout(() => {
          this.$Model.i3dSinkOpen();
        }, 1100);
      }
      if (code == 'fjsb') {
        setTimeout(() => {
          // 关闭透明
          this.$Model.i3dSinkOff();
        }, 500);
        setTimeout(() => {
          // 去到辅机设备视角
          this.$Model.i3dChangeViewByCode('fjsb');
        }, 1000);
      }
      if (code == 'spjk') {
        // Api.getHikFlvByStationCode().then((res) => {
        //   if (res.success) {
        //     const { records } = res.data;
        //     // this.videoListData = records.slice(9, 12);
        //     this.$Storage.set('videoListStorage', records);
        //   }
        // });
        setTimeout(() => {
          // 关闭透明
          this.$Model.i3dSinkOff();
        }, 500);
        setTimeout(() => {
          // 打开所有摄像头
          this.$Model.i3dChangeCamera('all', 'S2', 1);
        }, 1500);
      }

      //水工建筑
      if (code == 'sgjz') {
        setTimeout(() => {
          // 关闭透明
          this.$Model.i3dSinkOff();
        }, 500);
        setTimeout(() => {
          this.$Model.i3dHighLight(['SG001'], 'T2', '1', '1');
        }, 1000);
        setTimeout(() => {
          this.$Model.i3dChangeViewByCode('dz');
        }, 1500);
      }
      if (code == 'cgpx') {
        setTimeout(() => {
          // 电站参观运行水轮机
          EventBus.$emit('isStartVisit', true);
          this.$Model.i3dDeviceRun();
        }, 500);
      }
      if (code == 'dzyy') {
        setTimeout(() => {
          //
          this.$Model.i3dActionPreview();
        }, 500);
      }
    },
    isSelected(index) {
      return index === this.selectedTab;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/variables';

.side_content {
  width: 112px;
  // height: 218px;
  background: url('../assets/hs/bg_次级导航背景.png') no-repeat center;
  position: fixed;
  left: 540px;
  background-size: 100% 100%;
  top: 95px;
  z-index: 99;
  .side_item {
    width: 90px;
    height: 34px;
    line-height: 34px;
    color: #fff;
    font-size: 18px;
    font-weight: 500;
    text-align: center;
    margin: 15px auto;
    cursor: pointer;
    &.active {
      background: url('../assets/hs/btn次级导航选中.png') no-repeat center;
      color: #fff;
    }
  }
}
</style>
